import { type YakurekiDetail } from '@/shared/types/yakurekiCore'

import { type HomeVisitLetterhead } from './homecareApi'
import { useHomeVisitLetterhead } from './useHomecare'
import { buildReportPage, printReportPages } from './printHomeVisitReport'
import { RecipientPrintButton } from './RecipientPrintButton'

interface Props {
  event: YakurekiDetail
  letterhead: HomeVisitLetterhead
}

// 報告書を出す口。報告書タブのカード右上。本文は 1 つで、頭書きだけを宛先ごとに替えて刷る。
export const HomeVisitPrintButton = ({ event, letterhead }: Props) => (
  <RecipientPrintButton
    recipients={letterhead.recipients}
    ariaLabel="訪問報告書を印刷"
    print={(targets) =>
      printReportPages(
        targets.map((recipient) =>
          buildReportPage(event, letterhead, recipient)
        )
      )
    }
  />
)

// 報告書タブのカード右上に置く口。頭書きの材料を引き、在宅の患者に紐付く訪問だけ印刷を出す
// (旧い在宅の記録は null で出さない)。タブを開いたときだけ引く。
export const HomeVisitPrintAction = ({ event }: { event: YakurekiDetail }) => {
  const { data: letterhead } = useHomeVisitLetterhead(event.id)
  if (!letterhead) return null
  return <HomeVisitPrintButton event={event} letterhead={letterhead} />
}
